import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_COMMISSIONS_STATE,
});

export const resetMessage = () => ({
  type: types.RESET_COMMISSIONS_MESSAGE,
});

export const fetchCommissions = (startDate, endDate) => ({
  type: types.FETCH_COMMISSIONS.REQUEST,
  startDate,
  endDate,
});

export const fetchCommissionsSuccess = (commissions, startDate, endDate) => ({
  type: types.FETCH_COMMISSIONS.SUCCESS,
  commissions,
  startDate,
  endDate,
});

export const fetchCommissionsFailure = (error) => ({
  type: types.FETCH_COMMISSIONS.FAILURE,
  error,
});
